import { EboEvent } from '../base-classes/ebo-event';
import { Company } from '../organization/company/company';
import { Contract } from '../organization/company/contract';
import { SettlementFile } from './settlement-file';
import { SettlementSection } from './settlement-section';

export class CompanySettlement extends EboEvent {
  companyID: string;
  company: Company;
  externalCompanyID: string;
  externalCompany: Company;
  contractID: string;
  contract: Contract;
  netAmount: number;
  files: SettlementFile[];
  sections: SettlementSection[];

  constructor(jsonData: Partial<CompanySettlement>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.externalCompany) {
        this.externalCompany = new Company(jsonData.externalCompany);
      }
      if (jsonData.contract) {
        this.contract = new Contract(jsonData.contract);
        // Fallback to contract's companies if not directly provided
        if (!this.company && this.contract.company) {
          this.company = this.contract.company;
        }
        if (!this.externalCompany && this.contract.externalCompany) {
          this.externalCompany = this.contract.externalCompany;
        }
      }
      if (jsonData.files) {
        this.files = jsonData.files.map((item) => new SettlementFile(item));
      }
      if (jsonData.sections) {
        this.sections = jsonData.sections.map((item) => new SettlementSection(item));
      }
    }
  }

  toShortString(): string {
    return `${this.company?.name}: ${this.eventDate.format('M/D/YY')}`;
  }
}
